module.exports = __webpack_public_path__ + "img/21.237a18f3.jpg";